import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { Id as RequirementId } from '../RequirementsWithUnknown';

export const RequirementsJoined = struct({
	equalsType: EqualsType,
	values: array(array(RequirementId)),
});
